import { func, number } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import AddCreatives from '../AddCreatives';

function AddCreativesButton({ opportunityId, onSuccess, toggle }) {
  return (
    <>
      <ModalHeader toggle={toggle}>Upload Creative</ModalHeader>
      <ModalBody>
        <AddCreatives opportunityId={opportunityId} onSuccess={onSuccess} />
      </ModalBody>
    </>
  );
}

AddCreativesButton.propTypes = {
  opportunityId: number.isRequired,
  onSuccess: func.isRequired,
  toggle: func.isRequired,
};

export default createModalToggle('Add Creatives', AddCreativesButton);
export { AddCreativesButton }; // for unit tests
